export const config = {
    hybridBaySize: 3.4,
    hybridFloorHeight: 3.125,
    corridorBaySize: 3.4,
    corridordFloorHeight: 3.125,
    towerBaySize: 3.4,
    towerFloorHeight: 3.125,
    rowhouseBaySize: 3.4,
    rowhouseFloorHeight: 3.125,
    highRiseLimit: 20,
    maxBodyLengthHybrid: 80,
    maxBodyLengthCorridor: 30,
    smallFieldSize: 50,
    shortFieldSize: 255,
    largerFieldSize: 400,
}
